import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useState, useEffect } from 'react'
import autoTable from 'jspdf-autotable';
import jsPDF from "jspdf";
import moment from "moment";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";

import { callAddFontNirmalaBold } from '../../../styles/fonts/Nirmala-bold';
import { callAddFontNirmalaNormal } from '../../../styles/fonts/Nirmala-normal';
import { excelConfig } from '../../../configs/excelConfig';
import { fetchApi } from '../../../services/apiService';
import { hasAccess, NumberFormatter, jsPdfHeaderFooter, jsPdfDidParseCellCallback, jsPdfWillDrawCellCallback } from '../../../components/generics/helper';
import { Loader } from '../../../components/generics/Loader';
import { StyledTableRow, StyledTableCell } from "../../../components/Table/TableStyle";
import CommonTableHeaderRow from '../../../components/Table/CommonTableHeaderRow';
import excelExport from '../../../services/exports/export-excel';
import Modal from "../../../components/generics/Modal";

const nowrapCellStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const ItemIssueRegisterReportPopup = (props) => {
    const { itemIssueReportFilters, hideMoreDetailsCallback, selectedItemDetails } = props
    const { itemName, categoryTitle, subCategoryTitle, itemId } = selectedItemDetails;
    const { enqueueSnackbar } = useSnackbar();

    const userToken = useSelector((state) => state.login.userToken);
    const { selectedRolesRights = [], adminType = 0 } = useSelector((state) => state.login?.userData);
    const userData = useSelector((state) => state.login.userData);

    const [isPdfLoading, setIsPdfLoading] = useState(false);
    const [isPdfLoaded, setIsPdfLoaded] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getIIRSearchParams = () => {
        let IIRSearchParams = {}

        if (itemId) {
            IIRSearchParams = { ...IIRSearchParams, searchItemIds: itemId };
        }
        if (itemIssueReportFilters?.searchVehBrandId !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchVehicleOemIds: itemIssueReportFilters.searchVehBrandId };
        }
        if (itemIssueReportFilters?.searchVehModelId !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchVehicleModelIds: itemIssueReportFilters.searchVehModelId };
        }
        if (itemIssueReportFilters?.searchVehId !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchVehicleIds: itemIssueReportFilters.searchVehId };
        }
        if (itemIssueReportFilters?.searchStoreIds !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchStoreIds: itemIssueReportFilters.searchStoreIds };
        }
        IIRSearchParams.showOnlyPurchaseItems = itemIssueReportFilters.showOnlyPurchaseItems;
        IIRSearchParams.formattedDate = "Y";
        IIRSearchParams.searchReportingView = 'D';
        IIRSearchParams.dateType = itemIssueReportFilters.dateType;
        if (itemIssueReportFilters.dateType === 'J') {
            IIRSearchParams.fromDate = moment(itemIssueReportFilters?.fromDate).format('YYYY-MM-DD');
            IIRSearchParams.toDate = moment(itemIssueReportFilters?.toDate).format('YYYY-MM-DD');
        } else {
            IIRSearchParams.fromDate = moment(itemIssueReportFilters?.fromDate).format('YYYY-MM-DD');
            IIRSearchParams.toDate = moment(itemIssueReportFilters?.toDate).format('YYYY-MM-DD');
        }

        return IIRSearchParams;
    };

    const generateItemIssueReportPopupData = async () => {
        if (!itemId) return;
        setIsLoading(true);
        try {
            const IIRSearchParams = getIIRSearchParams();

            const response = await fetchApi('reports/getIssueItemsRegisterReportData', IIRSearchParams, userToken);
            setIsLoading(false);

            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                if (response.data.issueRegisterDetailViewData.length > 0) {
                    enqueueSnackbar('Item Issue Report Popup Data Loaded Successfully', { variant: 'success', key: Date.now() });
                    setTableData(response?.data?.issueRegisterDetailViewData);

                } else {
                    enqueueSnackbar('Ooops! No Record Found', { variant: 'error' });
                    setTableData([]);
                }
            } else {
                enqueueSnackbar(response.errorMessage, { variant: 'error' });
                setTableData([]);
            }
        } catch (err) {
            let message = 'Item Issue Report Popup Loading Failed';
            if (!err.message) {
                err.message = message
            }
            enqueueSnackbar(err.message, { variant: 'error' });
            setTableData([])

            return { data: [], totalRecords: 0 };
        }
    }

    const columnDefs = [
        { headerName: 'Issue Date', pdfHead: 'Issue Date', xlCol: { dataType: 'string', dataFormatter: null, width: 15 }, field: 'issueDate', headerSx: { width: '130px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Jobcard Date', pdfHead: 'Jobcard Date', xlCol: { dataType: 'string', dataFormatter: null, width: 15 }, field: 'jobCardDate', headerSx: { width: '130px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Time', pdfHead: 'Time', xlCol: { dataType: 'string', dataFormatter: null, width: 15 }, field: itemIssueReportFilters.dateType === 'J' ? 'jobCardTime' : 'issueTime', headerSx: { width: '130px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Job Card No.', pdfHead: 'Job Card No. ', field: 'jobCardNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Vehicle Number', pdfHead: 'Vehicle No. ', field: 'vehicleNo', xlCol: { dataType: 'string', dataFormatter: null, width: 30 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Vehicle Code', pdfHead: 'Vehicle Code ', field: 'vehicleCode', xlCol: { dataType: 'string', dataFormatter: null, width: 30 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Issue Store', pdfHead: 'Issue Store', xlCol: { dataType: 'string', dataFormatter: null, width: 30 }, field: 'issueStoreName', headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Issue By', pdfHead: 'Issue By', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, field: 'issuedByName', headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Issue QTY', pdfHead: 'Issue QTY', field: 'qty', xlCol: { dataType: 'quantity', dataFormatter: null, width: 15 }, headerSx: { width: '100px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Amount', pdfHead: 'Amount', field: 'amount', xlCol: { dataType: 'currency', dataFormatter: null, width: 15 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
    ];

    const printReport = () => {
        try {
            setIsPdfLoading(true);
            setIsPdfLoaded(false);
            const pdfColumns = columnDefs.map((col) => {
                return { header: col.pdfHead, dataKey: col.field, xlCol: col.xlCol }
            });
            jsPDF.API.events.push(["addFonts", callAddFontNirmalaBold]);
            jsPDF.API.events.push(["addFonts", callAddFontNirmalaNormal]);
            const doc = new jsPDF({
                orientation: 'l',
                format: 'a4',
            });
            var totalPagesExp = '{total_pages_count_string}';
            doc.autoTableSetDefaults({
                headStyles: { fontSize: 9, halign: 'left' },
            });
            doc.setProperties({
                title: `itemIssueRegisterSummaryReport-${moment().format('DD-MMM-YY-HH-mm')}.pdf`,
                subject: "Item Issue Register Report Summary View",
                author: "Maven Tech Labs Pvt. Ltd.",
                keywords: "maven tech, Maintenance system, item issue register",
                creator: "MTLPL",
            });
            doc.line(0, 17, doc.getPageWidth(), 17);
            doc.setFontSize("12");
            doc.setFont(undefined, "bold");
            doc.text(`Item Name: ${itemName} | Category: ${categoryTitle} | Subcategory: ${subCategoryTitle}`, 5, 22);
            doc.setFontSize("10");
            doc.setFont(undefined, "normal");
            autoTable(doc, {
                startY: 24,
                margin: { top: 2, left: 5, right: 5, bottom: 5 },
                alternateRowStyles: {
                    fillColor: [255, 255, 255]
                },
                columns: pdfColumns,
                body: tableData,
                columnStyles: {
                    0: { minCellWidth: 12 },
                    1: { minCellWidth: 12 },
                    2: { minCellWidth: 12 },
                    3: { minCellWidth: 12 },
                    4: { minCellWidth: 12 },
                    5: { minCellWidth: 12 },
                    6: { minCellWidth: 12 },
                    7: { minCellWidth: 12 },
                    8: { minCellWidth: 10, halign: 'right' },
                    9: { minCellWidth: 12, halign: 'right' },
                },
                theme: 'grid',
                headStyles: {
                    fillColor: [30, 89, 167],
                },
                didParseCell: (data) => {
                    jsPdfDidParseCellCallback(data, pdfColumns, 0);
                },
                willDrawCell: (data) => {
                    jsPdfWillDrawCellCallback(data);
                },
                didDrawPage: function (data) {
                    data.settings.margin.top = 16;
                    const reportTitle = `Maintenance System | Item Issue Register Summary Report`;
                    jsPdfHeaderFooter(data, reportTitle, userData, totalPagesExp);
                },
            },
            );
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp)
            }
            setIsPdfLoaded(true);
            setTimeout(() => {
                // document.getElementById('output').data = doc.output('datauristring', 'itemIssueRegisterSummary.pdf');
                const blob = doc.output('blob');
                const url = URL.createObjectURL(blob);
                document.getElementById('output').data = url;
                setIsPdfLoading(false);
            }, 1000);
        } catch (err) {
            console.log(err);
            setIsPdfLoading(false);
            setIsPdfLoaded(false);
        }
    }

    const reportExcelExport = async () => {
        try {
            setIsPdfLoading(true);
            const xlColumns = columnDefs.map((col) => {
                return { colHeader: col.headerName, field: col.field, xlCol: col.xlCol }
            });
            const reportTitle = `Maintenance System | Item Issue Register Summary Report`;
            const xlConfig = {
                ...excelConfig,
                columns: xlColumns,
                fileName: `Item_Issue_Summary_Report_${moment(new Date()).format("DD_MMM_YYYY_ddd_HH_mm")}.xlsx`,
                showFilterSection: false,
                workSheetTitle: `Item_Issue_Register_Report`,
                headerFooter: {
                    firstHeader: `&L&14&K104FA2 ${reportTitle} &R&B&12 Company Name: ${userData.companyName}`,
                    firstFooter: `&L&12 Report By : ${userData.userFullName}  [ ${userData.branchName} ] &C&12 Report Time :  ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")} &R&12 Page: &P of &N`
                },
                sheetHeaderData: [{
                    "caption": "Report Name :",
                    "value": `Item Issue Register Summary Report`,
                    "colSpan": 7
                }, {
                    "caption": "Company Name :",
                    "value": userData.companyName,
                    "colSpan": 6
                }],
            };
            await excelExport.processExcel(xlConfig, tableData);
            setIsPdfLoading(false);
        } catch (err) {
            console.log(err);
            setIsPdfLoading(false);
        }
    }

    const backToScreenView = () => {
        setIsPdfLoaded(false);
    }

    useEffect(() => {
        generateItemIssueReportPopupData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemId]);

    return (
        <div className="div-more-details-modal">
            <Modal width={"86%"}
                updateModal={hideMoreDetailsCallback}
                isModal={true}
                headTxt={`Item Name: ${itemName}`}
                midTxt={`Category: ${categoryTitle}`}
                endTxt={`Subcategory: ${subCategoryTitle}`}
            >
                <>
                    <div className="more--details--contents jc--scroll">
                        {isLoading && <div style={{ width: "100%", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
                        {!isPdfLoaded &&
                            <div className="table--container">
                                <TableContainer component={Paper} className="jc--scroll" style={{ maxHeight: '375px' }}>
                                    <Table sx={{ minWidth: 1300 }} stickyHeader aria-label="sticky table">
                                        <CommonTableHeaderRow columnDefs={columnDefs} />
                                        <TableBody>
                                            {tableData && tableData.length ? tableData.map((row, index) => (
                                                row.isDataRow ?
                                                    <StyledTableRow key={`${row.rowType}-D-${index}`} className="grid">
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.issueDate}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.jobCardDate}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}> {itemIssueReportFilters.dateType === 'J' ? row.jobCardTime : row.issueTime}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.jobCardNo || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.vehicleNo || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.vehicleCode || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.issueStoreName || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.issuedByName || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.qty > 0 ? NumberFormatter(row.qty, 3) : ' '}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{NumberFormatter(row.amount, 2)}</StyledTableCell>
                                                    </StyledTableRow>
                                                    : null
                                                // row.isTotalRow &&
                                                // <StyledTableRow key={`${row.rowType}-T-${index}`} style={{ background: "#e4ebf5" }} className="grid">
                                                //     <StyledTableCell colSpan={row.colSpan} style={{ width: "50px", textAlign: "left", fontWeight: "700" }}>{row.totalCaption}</StyledTableCell>
                                                //     <StyledTableCell style={{ width: "100px", textAlign: "right" }}>{row.qty > 0 ? NumberFormatter(row.qty, 2) : ' '}</StyledTableCell>
                                                //     <StyledTableCell style={{ width: "103px", textAlign: "right" }}>{row.receivedQty > 0 ? NumberFormatter(row.receivedQty, 2) : ' '}</StyledTableCell>
                                                //     <StyledTableCell style={{ width: "100px", textAlign: "right" }}>{NumberFormatter(row.balanceQty, 2)}</StyledTableCell>
                                                //     <StyledTableCell style={{ width: "120px", textAlign: "right", fontWeight: "700" }}>{NumberFormatter(row.grossAmount, 2)}</StyledTableCell>
                                                // </StyledTableRow>
                                            )) :
                                                <StyledTableRow key={`$iir_no_records_row`}>
                                                    <StyledTableCell style={{ width: "100%" }} colSpan={columnDefs.length} align="center">
                                                        <div key="iir_no_records" className='no--records'> No Records </div>
                                                    </StyledTableCell>
                                                </StyledTableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        }
                        {isPdfLoaded && <object id="output" type="application/pdf" width="100%" height="380" title="MTLPL - Maintenance System - Item Issue Register Summary Report" aria-label="MTLPL - Maintenance System - Item Issue Register Summary Report"></object>}
                    </div>
                    <div className="btn--wrapper" style={{ padding: "15px 0" }}>
                        <div className="left--part"></div>
                        <div className="right--part">
                            <div className="dashed--btn" onClick={hideMoreDetailsCallback}>close</div>
                            {!isPdfLoaded && hasAccess(selectedRolesRights, '4112', adminType) && <div className="search--btn" onClick={() => reportExcelExport()}>Export As Excel</div>}
                            {!isPdfLoaded && hasAccess(selectedRolesRights, '4113', adminType) && <div className="search--btn" onClick={() => printReport()}>Export As Pdf</div>}
                            {!isPdfLoaded && hasAccess(selectedRolesRights, '4111', adminType) && <div className="search--btn" onClick={() => printReport()}>print</div>}
                            {isPdfLoaded && <div className="search--btn" onClick={() => backToScreenView()}>back</div>}
                            {isPdfLoading && <div style={{ width: "100px", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
                        </div>
                    </div>
                </>
            </Modal>
        </div>
    );
}
export default ItemIssueRegisterReportPopup;